'use client';

import SectionCard from '@/app/(website)/components/SectionCard';
import SectionHeader from '@/app/(website)/components/SectionHeader';
import Book1 from '@/assets/icons/Book-1.svg';
import Book2 from '@/assets/icons/Book-2.svg';
import Details from '@/assets/icons/Details.svg';
import Scale from '@/assets/icons/Scale.svg';
import {useEffect, useRef, useState} from 'react';

const sources = [
  {
    icon: <Scale width={64} height={64} />,
    title: 'Normativa nazionale',
    description:
      'Leggi, decreti, regolamenti, testi unici, norme tecniche, decreti attuativi e prassi rilevanti per il settore edilizio, urbanistico, energetico e strutturale, aggiornati quotidianamente.',
  },
  {
    icon: <Book1 width={64} height={64} />,
    title: 'Normativa regionale e locale',
    description:
      "Regole, modulistica, specifiche di interoperabilità, procedimenti e fonti territoriali rilevanti per l'operatività concreta delle pratiche.",
  },
  {
    icon: <Book2 width={64} height={64} />,
    title: 'Fonti tecniche e procedurali',
    description:
      'Linee guida, portali istituzionali, istruzioni operative, FAQ ufficiali, documentazione tecnica e schede prodotto utili per verifiche e istruttorie.',
  },
  {
    icon: <Details width={64} height={64} />,
    title: 'Fonti personali',
    description:
      'Possibilità di integrare la conoscenza di Normo.ai con documenti dello studio, relazioni, standard interni, modelli, capitolati, checklist e archivi documentali proprietari.',
  },
];

export default function SourcesArchEng() {
  const [isVisible, setIsVisible] = useState(false);
  const gridRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      {threshold: 0.1},
    );

    if (gridRef.current) {
      observer.observe(gridRef.current);
    }

    return () => {
      if (gridRef.current) {
        observer.unobserve(gridRef.current);
      }
    };
  }, []);

  const getClass = (index: number) => {
    const delays = ['', 'delay-200', 'delay-500', 'delay-700'];
    return `transition-all duration-1000 ease-in-out transform ${delays[index] ?? ''} ${
      isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-40'
    }`;
  };

  return (
    <div id="sources" className="flex flex-col items-center gap-10 py-16 px-8">
      <SectionHeader
        badgeText="Fonti"
        title={
          <>
            Fonti{' '}
            <span className="rounded-[2rem] rounded-br-[8px] py-0 px-2 md:px-4 bg-secondary text-primary">
              informative
            </span>{' '}
            per l&apos;ingegneria e l&apos;architettura
          </>
        }
        subtitle="Normo.ai utilizza fonti normative, regolamentari e tecniche per offrire una base di lavoro affidabile, aggiornata e utile nella pratica professionale di architetti, ingegneri e studi tecnici."
        titleAnimationStart="bottom"
      />
      <div
        className="grid grid-cols-1 md:grid-cols-2 max-w-[912px] gap-8"
        ref={gridRef}
      >
        {sources.map((source, index) => (
          <SectionCard
            icon={source.icon}
            title={source.title}
            text={source.description}
            key={index}
            className={getClass(index)}
          />
        ))}
      </div>
    </div>
  );
}
